var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.project.isLoaded)?_c('page-placeholder',[_c('v-row',[_c('v-col',{attrs:{"cols":12}},[_c('website-pages-positioned-count-evolution')],1),_c('v-col',{attrs:{"cols":12}},[_c('website-pages-best-positioned-pages')],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }